module.exports = __webpack_public_path__ + "static/media/line-selected.c3e947c1.svg";